<template>
	<v-card>
		<v-card-title class="purple darken-2">
    <h1 class="white--text">
      <span class="botter-chat-icon"></span>
      Smooch App Config
    </h1>
    </v-card-title>
    <v-card-text>
      <v-form>
      <label>Name</label>
      <label>App Id</label>
      <v-text-field
        v-model = "input.app_id"
        placeholder="App Id"
        outline />
      <label>API Key</label>
      <v-text-field
        v-model = "input.api_key"
        placeholder="API Key"
        outline />
    </v-form>
    </v-card-text>
    <v-card-actions>
      <v-spacer />
      <v-btn @click="$emit('closed')">Close</v-btn>
      <v-btn class="purple darken-2 white--text" @click="updateApp">Save</v-btn>
    </v-card-actions>
	</v-card>
</template>

<script>
export default {

  name: 'SmoochNotificationsConfig',
  props: {
  	pageId: {
  		type: String,
  		required: true
  	}
  },
  data () {
    return {
    	appData: null,
      input: {
        app_id: '',
        api_key: '',
      }
    }
  },
  computed: {
  	botId() {
  		return this.$store.state.bot.botId
  	}
  },
  mounted() {
  	this.getApp()
  },
  methods: {
  	getSmoochApps() {
  		this.getApps()
  	},
  	async getApp() {
      this.$store.dispatch('setLoader', true)
  		this.$http_chat.get(`/bots/apps/smooch/${this.pageId}`).then(({ data }) =>{
        this.$store.dispatch('setLoader', false)
        if(data.smooch_apps && data.smooch_apps.length) {
          this.appData = data.smooch_apps[0]
          this.input = data.smooch_apps[0]
        } else {
          this.$store.dispatch('setErrorMessage', true)
          this.$store.dispatch('setLoader', false)
        }
      }).catch(()=>{
        this.$store.dispatch('setErrorMessage', true)
        this.$store.dispatch('setLoader', false)
      })
  	},
    updateApp() {
      this.$store.dispatch('setLoader', true)
      const payload = this.$_.omit(this.input, ['_id'])
      this.$http_chat.put(`/bots/${this.botId}/apps/smooch`, payload).then(({ data })=>{
        this.$store.dispatch('setSnackbar', {
            text: `Updated Successfully`,
            color: 'success'
          })
          this.$store.dispatch('setLoader', false)
          this.$emit('success', data)
      }).catch(()=>{
        this.$store.dispatch('setLoader', false)
        this.$store.dispatch('setErrorMessage', true)
      })
    }
  }
}
</script>

<style lang="css" scoped>
</style>